<template>
  <div
    class="criteria-checklist"
    @click.stop
  >
    <div v-if="options">
      <div v-if="hasOptions" style="padding-bottom:10px;">
        <div class="sort-options" v-if="isResultFromSearch" @click="orderByAsc"><img src="@/assets/img/menu_icons/sortazlang.gif"/><span v-text="$t('DocumentGrid.ascending')"></span></div>
        <div class="sort-options" v-if="isResultFromSearch" @click="orderByDesc"><img src="@/assets/img/menu_icons/sortzalang.gif"/><span v-text="$t('DocumentGrid.descending')"></span></div>
        <hr class="facet-division">
        <input type="text" id="facetFilter" autocomplete="off" v-bind="searchString" v-on:keyup="updateFacetValues($event)" :placeholder="$t('DocumentGrid.facetFilter')">
        <hr class="facet-division">
        <ul
          class="criteria-list"
          :style="{
            'max-height': maxHeight + 'px'
          }"
          @scroll="handleScroll"
        >
          <li v-if="isVisibleSelectAll"
            class="criteria-list-item" @click="selectAllOptions()"
          >
            <checkbox-input  :value="hasAllSelected"/>
            <label style="font-weight:bold"
              v-text="selectAllText(hasAllSelected)"
              :title="selectAllText(hasAllSelected)"
            />
          </li>
          <li
            class="criteria-list-item"
            v-for="(option, key) in options"
            :key="key"
            @click="toggleOption(option)"
          >
            <checkbox-input :value="option.Selected" />
            <label
              v-html=formatOptionValue(option.Value)
              :title="option.Value"
            />
          </li>
        </ul>
      </div>
      <spinner
      v-else
      class="criteria-list"
      :message="$t('DocumentGrid.searchingFilters')"
      />
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import mixins from 'mixins'
import CheckboxInput from '../../../Checkbox/CheckboxInput'

import Spinner from '../../../Spinner.vue'

export default {
  name: 'CriteriaCheckList',
  components: {
    'checkbox-input': CheckboxInput,
    'spinner': Spinner
  },
  mixins: [mixins],
  props: {
    item: {
      default: function () {
        return {}
      },
      type: Object
    },
    property: {
      default: '',
      type: String
    },
    maxHeight: {
      default: 180,
      type: Number
    },
    facetOptions: {
      default: function () {
        return []
      },
      type: Array
    },
    resultFromSearch: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      filterActive: false,
      searchString: '',
      selectedCount: 0,
      expandRate: 50,
      currentOptions: this.facetOptions,
      hasAllSelected: false
    }
  },
  created () {
    let self = this
    this.$eventBus.$on('resetCriteriaList', () => {
      if (self.currentOptions != null) {
        self.currentOptions.forEach(item => {
          item.Selected = false
        })
      }
      self.selectedCount = 0
      self.hasAllSelected = false
    })

    this.$eventBus.$on('deleteCriterion', (criterion) => {
      if (self.currentOptions != null && self.item.Caption === criterion.TypeName) {
        self.currentOptions.forEach(item => {
          if (item.Value === criterion.Value) {
            item.Selected = false
            self.selectedCount -= 1
          }
        })
        self.hasAllSelected = false
      }
    })
  },
  computed: {
    hasOptions () {
      let self = this
      return _.size(self.currentOptions) >= 0
    },
    options () {
      if (this.currentOptions !== null) {
        if (this.filterActive) {
          return this.currentOptions.filter(x => x.Visible === true && x.Filtered === true)
        } else {
          return this.currentOptions.filter(x => x.Visible === true)
        }
      }
      return []
    },
    isResultFromSearch () {
      return !this.resultFromSearch
    },
    isVisibleSelectAll () {
      return (this.options.length > 1)
    }
  },
  watch: {
    facetOptions: function (newValue, oldValue) {
      this.currentOptions = newValue
      this.expandOptions(this.currentOptions)
    },
    selectedCount: function () {
      if (this.selectedCount < 0) {
        this.selectedCount = 0
      }
      this.$emit('filterActive', this.selectedCount > 0)
    }
  },
  methods: {
    toggleOption (option) {
      let hash = this.generateHash(`${this.item.Caption}${option.Value}${this.item.FieldName}`)
      if (option.Selected) {
        this.removeFilter(option.Value, hash)
      } else {
        this.addFilter(this.item.Caption, option.Value, this.item.FieldName, hash)
      }
      option.Selected = !option.Selected
    },
    handleScroll: _.debounce(function (event) {
      if (event.target.scrollHeight - event.target.scrollTop - this.maxHeight < 5) {
        this.expandOptions(this.currentOptions)
      }
    }, 200),
    expandOptions (options) {
      let self = this
      let rate = this.expandRate
      if (options !== null) {
        options.forEach(item => {
          if (rate > 0 && !item.Visible) {
            if (self.filterActive === true) {
              if (item.Filtered === true) {
                item.Visible = true
                rate--
              }
            } else {
              item.Visible = true
              rate--
            }
          }
        })
      }
    },
    selectAllOptions () {
      if (this.options != null) {
        this.options.forEach(option => {
          let hash = this.generateHash(`${this.item.Caption}${option.Value}${this.item.FieldName}`)
          if (!this.hasAllSelected) {
            if (option.Selected !== true) {
              this.addFilter(this.item.Caption, option.Value, this.item.FieldName, hash)
              option.Selected = true
            }
          } else {
            this.removeFilter(option.Value, hash)
            option.Selected = false
          }
        })
        this.hasAllSelected = !this.hasAllSelected
      }
    },
    orderByAsc () {
      this.$store.commit('setSortOrder', {field: this.item.FieldName, order: 'asc'})
      this.$eventBus.$emit('orderByEvent')
    },
    orderByDesc () {
      this.$store.commit('setSortOrder', {field: this.item.FieldName, order: 'desc'})
      this.$eventBus.$emit('orderByEvent')
    },
    formatOptionValue (value) {
      let sanitizedValue = this.sanitizerHTML(value)
      if (sanitizedValue != null && sanitizedValue.toString().trim() !== '') { return sanitizedValue }
      return '&nbsp'
    },
    selectAllText (isAllSelect) {
      if (isAllSelect) { return this.$t('DocumentGrid.deSelectAll') }
      return this.$t('DocumentGrid.selectAll')
    },
    addFilter (TypeName, Value, FieldName, Hash) {
      this.selectedCount++
      this.$emit('addFilter', {
        TypeName: TypeName,
        Value: Value,
        FieldName: FieldName,
        Hash: Hash})
    },
    removeFilter (Value, Hash) {
      this.selectedCount--
      this.$emit('removeFilter', {
        Value: Value,
        Hash: Hash})
    },
    updateFacetValues: _.debounce(function (event) {
      let self = this
      let filter = event.target.value.toLowerCase()
      if (filter !== undefined && filter !== null && filter !== '') {
        self.filterActive = true
        self.currentOptions.forEach(item => {
          if (item.Value !== null) {
            if (item.Value.toString().toLowerCase().indexOf(filter) < 0) {
              item.Visible = false
              item.Filtered = false
            } else {
              item.Visible = false
              item.Filtered = true
            }
          }
        })
      } else {
        self.filterActive = false
        self.currentOptions.forEach(item => {
          item.Visible = false
          item.Filtered = false
        })
      }
      self.expandOptions(self.currentOptions)
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../../kit-components/uikit';
  @import '../../../../kit-components/styling/definitions';

  .criteria-checklist {
    cursor: default;
    min-width: 150px;
    max-width:  calc(100% - 20px);
    background: white;
    top: 28px;
    z-index: 10;
    position: absolute;
    box-shadow: $primaryBoxShadow;
    min-height: 30px;

    .no-options-label {
      font-style: italic;
      font-weight: normal;
      font-size: 13px;
      color: $lightGreyFont;
      width: 100%;
      text-align: center;
      margin: 7px;
    }

    .criteria-list {
      width: 100%;
      padding: 5px;
      margin: 0;
      list-style: none;
      overflow-y: auto;
      overflow-x: auto;

      &-item {
        cursor: pointer;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 400;
        font-size: 13px;
        list-style: none;
        margin: 0;
        padding: 6px;

        label {
          cursor: inherit;
          color: $mediumGreyFont;
          display: block;
          text-indent: 10px;
        }

        &:hover {
          background-color: $lightGreyBackground;

          label {
            color: $darkGreyFont;
          }
        }
      }
    }

    .apply-button {
      height: 25px;
      border: 1px solid $primaryBorderColor;
      border-radius: 2px;
      background: #fff;
      font-size: 13px;
      color: $mediumGreyFont;
      width: calc(100% - 20px);
      margin: 5px 10px 10px 10px;

      &:hover {
        background: $mediumGreyBackground;
        border-color: $disabledBorderColor;
      }
    }
  }

  #facetFilter {
    height: 25px;
    border: 1px solid $primaryBorderColor;
    border-radius: 2px;
    background: #fff;
    font-size: 13px;
    color: $mediumGreyFont;
    width: calc(100% - 30px);
    margin: 7px;
  }

  .sort-options {
    padding-left: 10px;
    padding-top: 5px;
    cursor: pointer;
  }
  .sort-options span {
    padding-left: 3px;
    font-weight: lighter;
  }

  .facet-division {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  .sort-options:hover {
    background-color: #EEE;
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/Criteria/content/CriteriaCheckList.vue